import { render, staticRenderFns } from "./PlanStepTwo.vue?vue&type=template&id=49a79267&scoped=true"
import script from "./PlanStepTwo.vue?vue&type=script&lang=js"
export * from "./PlanStepTwo.vue?vue&type=script&lang=js"
import style0 from "./PlanStepTwo.vue?vue&type=style&index=0&id=49a79267&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a79267",
  null
  
)

export default component.exports